module.exports = __webpack_public_path__ + "static/img/9.989e35c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/sp/9.png
// module id = Uiz9
// module chunks = 0